<div class="headerOptions">
  <div class="headerOptions__option" (click)="deleteComment()">
    <img class="headerOptions__icon icon__delete" [src]="EIconPath.INTERACTION_DELETE" />
    <h6 class="headerOptions__text">{{ 'delete_comment' | ppTranslate }}</h6>
  </div>
</div>
